import {
  Button,
  ConfigProvider,
  DatePicker,
  Dropdown,
  message,
  Space,
} from "antd";
import es from "antd/locale/es_ES";
import fr from "antd/locale/fr_FR";
import hi from "antd/locale/hi_IN";
import { format, isBefore } from "date-fns";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  downloadReport,
  getDashboardDetails,
} from "../../../controller/services/dashboard";
import i18n from "../../../localization/i18n";
import BudgetSuccessModal from "../../../modals/BudgetSuccessModal";
import SaveBudgetModal from "../../../modals/SaveBudgetModal";
import {
  setLoading,
  setMenuTitle,
  setShowMenu,
} from "../../../redux/slices/common_slice";
import {
  setDashboardData,
  setSelectedMonth,
} from "../../../redux/slices/dashboard_slice";
import { getCurrentMonthYear } from "../../../utils/helper";

import dayjs from "dayjs";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/hi";

const MonthlyStaticsFirst = ({ surplusOrDeficit }) => {
  const [budgetModal, setBudgetModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [budgetName, setBudgetName] = useState("");
  const userName = useSelector((state) => state.user.userData.firstName);
  const formFirstName = useSelector((state) => state.form.userData.firstName);
  const splittedName = formFirstName
    ? formFirstName.split(" ")
    : userName.split(" ");
  const firstLetterUserName = splittedName[0]?.slice(0, 1);
  const lastLetterUserName = splittedName[1]?.slice(0, 1) || "";
  const upperCaseInitials =
    `${firstLetterUserName}${lastLetterUserName}`.toUpperCase();
  const params = useParams();
  const locationData = useLocation();
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  const selectedMonth = useSelector((state) => state.dashboard.selectedMonth);
  const [locale, setLocale] = useState(null);
  const selectedCurrency = useSelector(
    (state) => state.currency.currencySelected
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const showSaveBudgetModal = (visible) => {
    setBudgetModal(visible);
  };

  const showBudgetSuccessFulModal = (visible) => {
    setSuccessModal(visible);
  };

  useEffect(() => {
    if (i18n.language === "fr") {
      setLocale(fr);
    } else if (i18n.language === "es") {
      setLocale(es);
    } else if (i18n.language === "hi") {
      setLocale(hi);
    }
  }, [i18n.language]);
  // Handle date change
  const handleDateChange = (date, dateString) => {
    const payloadDate = dayjs(date).format("MM-YYYY");
    const dashboardPayload = { month: payloadDate, type: "all" };
    fetchDBdata(dashboardPayload);
    dispatch(setSelectedMonth(payloadDate));
  };

  const fetchDBdata = (payload) => {
    dispatch(setLoading(true));
    getDashboardDetails(payload)
      .then((dashboardRes) => {
        dispatch(setDashboardData(dashboardRes?.data));
      })
      .catch((err) => message.error(err?.message))
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const placeHolderDate = params?.id
    ? format(new Date(locationData?.state?.budgetData?.createdAt), "MMM, yyyy")
    : format(new Date(), "MMM, yyyy");
    
  const handleDownloadReport = () => {
    const payload = {
      currentMonth:
        dashboardData?.income?.currentMonth || getCurrentMonthYear(),
      lang: i18n.language,
      currency: selectedCurrency,
      totalExpense: Math.round(dashboardData?.totalExpense),
      totalIncome: Math.round(dashboardData?.totalIncome),
      remainBudget: Math.round(Math.abs(dashboardData?.remainBudget)),
      surplusOrDeficit: surplusOrDeficit,
    };
    dispatch(setLoading(true));
    downloadReport(payload)
      .then((resp) => {
        const byteArray = Object.values(resp.data.data?.buffer); // Convert object values to an array
        const uint8Array = new Uint8Array(byteArray); // Create a Uint8Array

        // Create a Blob from the Uint8Array
        const blob = new Blob([uint8Array], { type: "application/pdf" });

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Set the filename for the downloaded PDF
        link.setAttribute("download", resp.data.data?.filename); // Set a default filename

        // Append the link to the body and trigger the download
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        message.error(err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  const items = [
    {
      key: "1",
      label: (
        <div
          className="budget-popover underline pb-2"
          style={
            dashboardData?.totalExpense === 0 &&
            dashboardData?.totalIncome === 0
              ? { opacity: "0.6", cursor: "not-allowed" }
              : {}
          }
          onClick={() => {
            if (
              dashboardData?.totalExpense !== 0 &&
              dashboardData?.totalIncome !== 0
            ) {
              showSaveBudgetModal(true);
            }
          }}
        >
          {t("dashboard.saveToBudgets")}
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          className="budget-popover"
          onClick={(e) => {
            handleDownloadReport();
          }}
        >
          {t("dashboard.download")}
        </div>
      ),
    },
  ];

  return (
    <>
      <ConfigProvider locale={locale}>
        <div className="col-12 first-section-div">
          <div className="mobile-time-details-db">
            <div className="profile-details">
              <div className="user-name-img">{upperCaseInitials}</div>
              <div className="user-details">
                <h6>
                  <b>{formFirstName || userName}</b>
                </h6>
                <p className="mb-0">{t("dashboard.headTitle")}</p>
              </div>
            </div>
            <div className="other-details">
              <div className="static-icon-div">
                <ul className="list-inline mb-0">
                  <li className="list-inline-item">
                    <Space direction="vertical">
                      <Dropdown
                        menu={{
                          items,
                        }}
                        placement="bottomLeft"
                        trigger="click"
                      >
                        <Button>
                          <img
                            className="img-fluid"
                            src="/assets/images/icons/download-docs-icon.svg"
                            alt=""
                          />
                        </Button>
                      </Dropdown>
                    </Space>
                  </li>
                  <li className="list-inline-item">
                    <Button
                      className="w-auto h-auto"
                      onClick={() => {
                        navigate("/settings");
                        dispatch(setMenuTitle(t("settings.title")));
                        dispatch(setShowMenu(true));
                      }}
                    >
                      <img
                        className="img-fluid"
                        src="/assets/images/hamburger-with-border.svg"
                        alt=""
                      />
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="line-tag-mobile"></div>
          <h6 className="d-md-block d-lg-block d-xl-block mb-2">
            {t("dashboard.titleL1")}
          </h6>
          <h5 className="d-none d-sm-none d-md-block d-lg-block d-xl-block">
            {t("dashboard.mothlyBudget")}
          </h5>
          <div className="monthly-statics-details">
            <h5 className="d-block d-sm-block d-md-none d-lg-none d-xl-none mb-0">
              {t("dashboard.mothlyBudget")}
            </h5>
            <div className="monthly-calendar-div">
              <Space direction="vertical">
                <DatePicker
                  suffixIcon={
                    <img
                      src="/assets/images/icons/down-arrow-white.svg"
                      alt=""
                      className="img-fluid"
                    />
                  }
                  disabled={params?.id}
                  disabledDate={(date) => isBefore(new Date(), new Date(date))}
                  picker="month"
                  placeholder={placeHolderDate}
                  onChange={handleDateChange}
                  format="MMM,YYYY"
                  value={dayjs(selectedMonth, "MM-YYYY")}
                  inputReadOnly
                />
              </Space>
            </div>
            <div className="static-icon-div d-none d-sm-none d-md-flex d-lg-flex d-xl-flex">
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <Space direction="vertical">
                    <Dropdown
                      menu={{
                        items,
                      }}
                      placement="bottomLeft"
                      trigger="click"
                    >
                      <Button>
                        <img
                          className="img-fluid"
                          src="/assets/images/icons/download-docs-icon.svg"
                          alt=""
                        />
                      </Button>
                    </Dropdown>
                  </Space>
                </li>
                <li className="list-inline-item">
                  <Button
                    onClick={() => {
                      navigate("/settings/resources");
                      dispatch(setMenuTitle(t("settings.resources")));
                      dispatch(setSelectedMonth(format(new Date(), "MM-yyyy")));
                    }}
                  >
                    <img
                      className="img-fluid"
                      src="/assets/images/icons/hamburger-menu-icon-white.svg"
                      alt=""
                    />
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <SaveBudgetModal
          open={budgetModal}
          onClose={() => showSaveBudgetModal(false)}
          showSuccessModal={() => showBudgetSuccessFulModal(true)}
          setBudgetName={setBudgetName}
        />
        <BudgetSuccessModal
          open={successModal}
          onClose={() => showBudgetSuccessFulModal(false)}
          budgetName={budgetName}
        />
      </ConfigProvider>
    </>
  );
};

export default MonthlyStaticsFirst;
